import React from 'react'
import { mount } from 'enzyme'
import moment from 'moment'

import SmartRateRow from '../SmartRateRow'

import loan from './testData/loan'

describe('<SmartRateRow />', () => {
  let wrapper, props
  beforeEach(() => {
    const predictionResult = loan.predictionResults.filter(result => Boolean(result.smartRate))[0]
    props = {
      predictionResult
    }
    wrapper = mount(<SmartRateRow {...props} />)
  })
  it('should render the smartRate', () => {
    expect(wrapper.find('SmartRateRow__Cell').at(2).text()).toBe(props.predictionResult.smartRate.toString())
  })
  it('should render the date that the prediction was run', () => {
    expect(wrapper.find('SmartRateRow__Cell').at(3).text()).toBe(moment(props.predictionResult.createdAt).format('MM/DD/YYYY'))
  })
})
